import {Component} from '@angular/core';
import {NavController ,ToastController} from 'ionic-angular';
import {Api} from "../../providers/api";
import {ApiOffline} from "../../providers/api-offline";
import {ItemsPage} from "../items/items";
import {CartPage} from "../cart/cart";
import {ItemPage} from "../item-details/item-details";
import {IMAGES_BASE_URL,ApplicationVariables} from "../../providers/config";
import {CartManager} from "../../providers/cart-manager";
import { CART } from '../../providers/data';
import {Constants} from '../../providers/config';
import {MyOrderPage} from '../my-order/my-order';
import {LoginPage} from '../login/login';
import { MsgManager } from '../../providers/msg-manager';
import { Storage } from '@ionic/storage';
import { SpinnerDialog } from 'ionic-native';
import * as moment from 'moment';
import {GVLogger} from "../../services/gv-logger";


@Component({
  selector: 'page-search',
  templateUrl: 'search.html'
})
export class SearchPage {

  searchQuery = "";
  pageNo = 0;

  buttonsStatus =false;

  previousComplete = false;
  nextComplete = false;

  arrayItemsCount = 0;
  currentIndex = 0;

  cacheImages:any =false;
  isOfflineMode:any =false;

  constants = Constants;
  isWebstore = 0;
  showNegative = false;

  items = new Map();
  baseImageUrl = IMAGES_BASE_URL.imageBaseUrl;
  customerName = "";
  adpCustomerInfo:any={};
// view type
private showList: boolean;
private products:any;
  public viewType = "grid"
  constructor(public nav: NavController,public api:Api,
    private cartManager:CartManager,
    public toastCtrl:ToastController,
    private storage:Storage,
    private msgManager:MsgManager,
    private apiOffline:ApiOffline,
    private gVLogger: GVLogger) {

      this.adpCustomerInfo = this.cartManager.getAdpCustomerInfo();

      this.storage.get("negativeInventory").then((negativeInventory)=>{
     this.showNegative = negativeInventory;
   });

    this.isOfflineMode = ApplicationVariables.isOffline;

    this.storage.get("cacheImages").then((cache)=>{
     this.cacheImages = cache;
   });

    if(Constants.isWebstore){
      this.isWebstore = 1;
    }


    this.storage.get("defaultLayout").then((defaultLayout)=>{
     this.viewType = defaultLayout;
   });

    this.customerName = this.cartManager.getCustomerName();
  	this.showList = true;
  }

  viewItem(item){
    this.nav.push(ItemPage, {item: item})
  }



doInfinite(infinitescroll){

let cartItems = this.cartManager.getItems();

let startPoint = this.items.size;
var url = "products/search/"+startPoint+"?query=".concat(String(encodeURIComponent(this.searchQuery))+"&isWebStore="+this.isWebstore+"&customerId="+this.cartManager.getCustomerID());
    this.gVLogger.log(url);

    // get list items of a category as sample
    this.api.get(url).map(res => res.json())
    .subscribe(result => {

      if(result.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
        this.nav.setRoot(LoginPage);
      }else if(result.status == "200"){
        let map = new Map();

        map = this.items;

        if(result.data){
          for ( let item of result.data){

            item.productImagesDTO = JSON.parse(JSON.stringify(item.productImagesDTO.sort(function(a, b){return a.id - b.id})));
          item.quantity = 0 ;
          map.set(item.id,item);


        }
        for(let cartItem of cartItems){
             if(map.has(cartItem.id)){
               map.set(cartItem.id,cartItem);
             }

          }

        }


        this.items = map;

       infinitescroll.complete();

      }

      }, error =>{
        infinitescroll.complete();
      });




}




searchThroughItems(ev: any){
    // Reset items back to all of the items
    // this.initializeCustomers();
    this.gVLogger.log(ev.target.value);
    // Show the results
    this.showList = true;
// set val to the value of the searchbar
    let val = ev.target.value;
this.items = new Map() ;
if(ev.target.value!=""){


  this.searchQuery = val
  this.pageNo = 0;
  this.searchResolver(0,false);
  this.buttonsStatus = true;

  }else{
    this.items = new Map();
  }

  }

  searchResolver(startPoint,isPulltoRefresh){

    return new Promise((resolve,reject)=>{
        this.currentIndex = startPoint;

        if(ApplicationVariables.isOffline){
          this.apiOffline.searchProducts(this.searchQuery,startPoint).then(result => {

              let resp:any = {
                status:200,
                message:"Offline",
                data: []
              }
              for(var i=0; i<result.rows.length; i++)
              {
                  var json = JSON.parse(result.rows.item(i).json);
                  resp.data.push(json);
              }

              resolve(this.populateProducts(resp,isPulltoRefresh));

          })
        }else{
          resolve(this.searchProducts(this.searchQuery,startPoint,isPulltoRefresh));
        }
    });

  }


  searchProducts(query,startPoint,isPulltoRefresh){

    return new Promise((resolve,reject)=>{



    var url = "products/search/"+startPoint+"?query=".concat(String(encodeURIComponent(this.searchQuery))+"&isWebStore="+this.isWebstore+"&customerId="+this.cartManager.getCustomerID());
    this.gVLogger.log(url);

    // get list items of a category as sample
    this.api.get(url).map(res => res.json())
    .subscribe(result => {

      if(result.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
        this.nav.setRoot(LoginPage);
      }else if(result.status == "200"){

        if(!result.data){
          result.data = [];
        }



        resolve(this.populateProducts(result,isPulltoRefresh));
      }

      });

   });
  }



  populateProducts(result,isPulltoRefresh){

    return new Promise((resolve,reject)=>{

  let cartItems = this.cartManager.getItems();


       if(result.data.length >= this.arrayItemsCount || this.arrayItemsCount == 0){
            this.arrayItemsCount = result.data.length;
          }

    let map = new Map();

        //map = this.items;

        if(result.data){
          for ( let item of result.data){
          item.productImagesDTO = JSON.parse(JSON.stringify(item.productImagesDTO.sort(function(a, b){return a.id - b.id})));
          item.quantity = 0 ;
          map.set(item.id,item);


        }
        for(let cartItem of cartItems){
             if(map.has(cartItem.id)){
               map.set(cartItem.id,cartItem);
             }

          }

        }


        if(isPulltoRefresh){
              this.pageNo -= 1;
              this.nextComplete = false;
            }else{
              this.pageNo += 1;
              this.previousComplete = false;
            }

        this.items = map;
        resolve(true);
        this.gVLogger.log(this.items);
    });

  }



  onCancel(ev) {
    // Show the results
    this.showList = false;

    // Reset the field
    ev.target.value = '';
  }

 addProductToCart(item){
  this.cartManager.addProductToCart(item);
}

removeProductFromCart(product){
  this.cartManager.removeOneNew(product);
}

updateProductInCart(product){
  if(String(product.quantity) !=""){
    if(String(product.quantity).match(/^\d+$/)){
      this.cartManager.updateCartNew(product);
    }else{
      if (Number(product.minOrder) != 0) {
        product.quantity = Number(product.minOrder);
      } else {
        product.quantity = 1;
      }
      this.cartManager.updateCartNew(product);
    }
  }else{
      if (Number(product.minOrder) != 0) {
        product.quantity = Number(product.minOrder);
      } else {
        product.quantity = 1;
      }
      this.cartManager.updateCartNew(product);
  }


  }


imageNotFound(e,item){
   item.productImagesDTO[0].extension = "png";
   item.productImagesDTO[0].name = "dummy";
  }

  // switch to list view
  viewList() {
    this.viewType = 'list';
  }

  // swith to grid view
  viewGrid() {
    this.viewType = 'grid';
  }

  goToCart(){
    this.nav.push(CartPage);
  }


arrayUnique(array) {
    var a = array.concat();
    for(var i=0; i<a.length; ++i) {
        for(var j=i+1; j<a.length; ++j) {
            if(a[i].id === a[j].id)
                a.splice(j--, 1);
        }
    }

    return a;
}

// get discount percent
  discountPercent(originPrice, salePrice) {
    return Math.round((salePrice - originPrice) * 100 / originPrice)
  }


// updateItemQuantity(item){
//  var index= CART.items.map(function(x) {return x.id; }).indexOf(item.id);
//       if (index != -1) {
//           item.quantity = 0;
//       } else {
//           item.quantity = CART.items[index].quantity;
//       }
// }

discountCheck(discountPrice){ // if discount price is > 0, return true
    if(Number(discountPrice) > 0){
      return true;
    }else{
      return false;
    }
  }



  decimalLengthFixed(num,max){
    return Number(num).toFixed(Math.max(2, (num.toString().split('.')[1] || []).length))
  }


  gotoItemsPage(){
  this.nav.setRoot(ItemsPage);
  }

  gotoOrdersPage(){
     this.nav.setRoot(MyOrderPage);
  }
  logOut(){
     this.nav.setRoot(LoginPage);
  }





  bookmarkProduct(item){

  this.api.get("customers/likeProduct/"+this.cartManager.getCustomerID()+"/"+item.id)
  .map(res => res.json())
  .subscribe(result=>{

    if(result.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

        this.nav.setRoot(LoginPage);
      }else if(result.status == 200){
         item.isWishlisted = 1;
        this.gVLogger.log("success");
      }

  },err=>{
    this.gVLogger.log(err);
  });
}

unBookmarkProduct(item){

  this.api.get("customers/dislikeProduct/"+this.cartManager.getCustomerID()+"/"+item.id)
  .map(res => res.json())
  .subscribe(result=>{

    if(result.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

        this.nav.setRoot(LoginPage);
      }else if(result.status == 200){
         item.isWishlisted = 0;
        this.gVLogger.log("success");
      }

  },err=>{
    this.gVLogger.log(err);
  });

}


makeImageURL(dimensions,item){
  return this.cartManager.makeImageURL(dimensions,item);
}






loadMore(){ // Next button
    if(!this.nextComplete){
       SpinnerDialog.show("Loading...");
       this.buttonsStatus = false;
      this.gVLogger.log("New Scroll event.");
      let count = this.currentIndex + this.arrayItemsCount;
       var completed = this.searchResolver(count,false).then(()=>{ // isPulltoRefresh = false
         SpinnerDialog.hide();
         this.buttonsStatus = true;
       this.gVLogger.log("loadMore");
     });
    }else{
      this.presentToast("No more products to load.", 2000,"bottom");
    }
  }



loadPrvious() { // load Previous
  if(!this.previousComplete){
   SpinnerDialog.show("Loading...");
   this.buttonsStatus = false;
   let startPoint = this.currentIndex - this.arrayItemsCount ;
   if(this.nextComplete){
     startPoint -= this.arrayItemsCount;
     this.nextComplete = false;
   }
   this.gVLogger.log("Last fetchCount"+this.currentIndex+"pull Startpoint :"+ startPoint +"arraycount"+this.arrayItemsCount);
   if(startPoint >=0){
    this.searchResolver(startPoint,true).then(()=>{ // isPulltoRefresh = false
       this.gVLogger.log("Previous completed completed");
       SpinnerDialog.hide();
       this.buttonsStatus = true;
     });
   }else{
     this.buttonsStatus = true;
      this.presentToast("No more prodcts to load",2000,"bottom");
   }
 }else{
   this.presentToast("No more prodcts to load",2000,"bottom");
 }
}



presentToast(msg,duration,location) {
    this.gVLogger.log("TOAST: "+msg);
    let toast = this.toastCtrl.create({
      message: msg,
      duration: duration,
      position: location
    });
    toast.present();
  }
getDateString(date){
  return new Date(date).toDateString();
}

checkValidDate(date){
  // this.gVLogger.log("----------------------before date.replace--------------------", date);
  // //date.replace(/^\s+|\s+$/gm,'-');
  // // this.gVLogger.log("1" + date.trim() + "1");
  // date = date.trim();
  // // date.splice(" ", "-");

  // this.gVLogger.log("----------------------daaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaate--------------------", date);

  // if(date === null ||  date === "" || date === "null"){
  //   return false;
  // }
  // else{
  //   return true;
  // }

  if(moment(date, "DD-MM-YYYY").isValid()){
    return true;
  }
  else{
    return false;
  }
}



}



// WEBPACK FOOTER //
// ./src/pages/search/search.ts